// src/client/components/room/WaveVisualizer.jsx
import React from 'react';

export default function WaveVisualizer({ isListening, isAtlasSpeaking, theme }) {
  const isDark = theme === 'dark';
  
  // Atlas is the only one who gets the wave animation
  const isAtlasActive = isAtlasSpeaking;
  const waveformColor = isAtlasActive ? '#8a2be2' : (isDark ? '#555' : '#ccc'); 
  
  // Text color can still react to the human's mic status for safety
  const statusTextColor = isAtlasActive ? '#8a2be2' : (isListening ? '#0275d8' : (isDark ? '#555' : '#ccc'));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '250px' }}>
      <style>
        {`
          @keyframes wave {
            0% { transform: scaleY(0.2); }
            50% { transform: scaleY(1); }
            100% { transform: scaleY(0.2); }
          }
          .bar {
            width: 8px;
            border-radius: 4px;
            margin: 0 4px;
            transform: scaleY(0.2); /* Flattened state when dormant */
            transition: background-color 0.3s ease, transform 0.3s ease;
          }
          .bar.active {
            animation: wave 1.2s infinite ease-in-out;
          }
        `}
      </style>
      
      {/* The Waveform (Exclusive to Atlas) */}
      <div style={{ display: 'flex', height: '100px', alignItems: 'center' }}>
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div 
            key={i} 
            className={`bar ${isAtlasActive ? 'active' : ''}`}
            style={{ 
              height: '100%', 
              backgroundColor: waveformColor,
              animationDelay: `${i * 0.1}s` 
            }} 
          />
        ))}
      </div>
      
      {/* Status Indicator Text */}
      <p style={{ marginTop: '20px', fontSize: '18px', fontWeight: 'bold', color: statusTextColor, letterSpacing: '1px' }}>
        {isAtlasActive ? 'ATLAS IS SPEAKING...' : isListening ? 'LISTENING TO YOU...' : 'READY'}
      </p>
    </div>
  );
}